import Checkbox from "@mui/material/Checkbox";
import { useCallback, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ScreenContent from "../../../../components/layout/ScreenContent";
// icons
import {
  CloseOutlined,
  EditOutlined,
  LocationOnOutlined,
  PeopleOutlined,
  StoreOutlined,
} from "@mui/icons-material";
import { Box, Button, Card, Divider, IconButton, Tooltip } from "@mui/material";
import { green, grey, red } from "@mui/material/colors";
import { AgCharts } from "ag-charts-react";
import { AgGridReact } from "ag-grid-react";
import { isBoolean } from "lodash";
import isEmpty from "lodash/isEmpty";
import isNil from "lodash/isNil";
import size from "lodash/size";
import FlxGrid from "../../../../_src_shared/components/layout/FlxGrid";
import { columnTypesBoolean } from "../../../../_src_shared/utils/agGrid/columnTypes/columnTypesBoolean";
import { columnTypesPercent } from "../../../../_src_shared/utils/agGrid/columnTypes/columnTypesPercent";
import AgGridTableWrapper from "../../../../components/agGrid/AgGridTableWrapper";
import EditableDataFieldsRenderer from "../../../../components/common/EditableDataFieldsRenderer";
import RffForm from "../../../../components/finalForm/RffForm";
import RffAddressGeolocateField from "../../../../components/finalForm/inputs/RffAddressGeolocateField";
import PercentInput from "../../../../components/inputs/PercentInput";
import SelectInput from "../../../../components/inputs/SelectInput";
import SelectToggleInput from "../../../../components/inputs/SelectToggleInput";
import InputWrapper from "../../../../components/inputs/shared/InputWrapper";
import Flx from "../../../../components/layout/Flx";
import TitledHeaderWithSearch from "../../../../components/layout/TitledHeaderWithSearch";
import BasicModal from "../../../../components/modals/BasicModal";
import Txt from "../../../../components/typography/Txt";
import TitledCard from "../../../../components/ui/TitledCard";
import { selectOptionsEntityType } from "../../../../constants/selectOptions/selectOptionsEntityType";
import { selectOptionsUsaStates } from "../../../../constants/selectOptions/selectOptionsUsaStates";
import { useUnderwritingHook } from "../../../../hooks/useUnderwritingHook";
import { loanDrilldownSet } from "../../../../redux/actions/loanDrilldownActions";
import LoanDocumentGroupFilesCard from "../../shared/LoanDocumentGroupFilesCard";
import LoanDrilldownTabPanel from "../LoanDrilldownTabPanel";
import LoanDrilldownButtonAddEntity from "../../buttons/LoanDrilldownButtonAddEntity";
import { useNavigate } from "react-router-dom";
import LoanEntityDetailsCard from "./LoanEntityDetailsCard";
import { useReduxHook } from "../../../../hooks/useReduxHook";
import RedesignBanner from "../../../../components/ui/RedesignBanner";

const LoanDrilldownEntityTab = ({ value, tab }) => {
  const [quickFilter, setQuickFilter] = useState("");
  const { updateUnnestedObject } = useUnderwritingHook();
  const loanDrilldown = useSelector((state) => state.loanDrilldown);
  const dispatch = useDispatch();

  const [redesign, setRedesign] = useState(false);
  const { isHighLevelUser } = useReduxHook();

  const onEntityUpdate = ({ values, stopLoadingFn }) => {
    updateUnnestedObject({
      loanId: loanDrilldown?._id,
      data: values,
      objectName: "borrowerEntity",
      onSuccessFn: (response) => {
        stopLoadingFn();
        dispatch(loanDrilldownSet(response));
      },
    });
  };
  if (redesign && isHighLevelUser) {
    return (
      <Flx column>
        <RedesignContent />
        <RedesignBanner show active={redesign} onClick={setRedesign} />
      </Flx>
    );
  }
  return (
    <LoanDrilldownTabPanel value={value} tab={tab}>
      {/* <TitledHeaderWithSearch
        title={"Borrower Entity"}
        quickFilter={quickFilter}
        setQuickFilter={setQuickFilter}
      /> */}
      <TitledHeaderWithSearch
        title={"Loan Entity"}
        // endContent={<LoanDrilldownButtonAddEntity />}
        borderColor={"#eeeeee"}
      />

      <ScreenContent maxWidth={"xl"}>
        <FlxGrid gap={3} width="480px">
          <Flx column fw gap={3}>
            <EntityDetailsGroup
              quickFilter={quickFilter}
              onUpdateFn={onEntityUpdate}
            />

            <EntityAddressSection
              quickFilter={quickFilter}
              onUpdateFn={onEntityUpdate}
            />
            <EntityMembersCard />
          </Flx>

          <LoanDocumentGroupFilesCard showIfEmpty docGroup={"Entity Docs"} />
        </FlxGrid>
      </ScreenContent>
      <RedesignBanner
        show={isHighLevelUser}
        active={redesign}
        onClick={setRedesign}
      />
    </LoanDrilldownTabPanel>
  );
  // return (
  //   <LoanDrilldownTabPanel value={value} tab={tab}>
  //     <TitledHeaderWithSearch
  //       title={"Loan Entity"}
  //       endContent={<LoanDrilldownButtonAddEntity />}
  //       borderColor={"#eeeeee"}
  //     />
  //     <ScreenContent
  //       sx={{
  //         flexGrow: 1,
  //         width: "100%",
  //         margin: "0px auto",
  //       }}
  //     >
  //       {isEmpty(entities) ? (
  //         <Txt secondary>No related contacts added.</Txt>
  //       ) : (
  //         <>
  //           <EntityCardList entities={entities} />
  //           <Divider>OLD</Divider>
  //           <ScreenContent maxWidth={"xl"}>
  //             <FlxGrid gap={3} width="480px">
  //               <Flx column fw gap={3}>
  //                 <EntityDetailsGroup
  //                   quickFilter={quickFilter}
  //                   // onUpdateFn={onEntityUpdate}
  //                 />

  //                 <EntityAddressSection
  //                   quickFilter={quickFilter}
  //                   // onUpdateFn={onEntityUpdate}
  //                 />
  //                 <EntityMembersCard />
  //               </Flx>

  //               <LoanDocumentGroupFilesCard
  //                 showIfEmpty
  //                 docGroup={"Entity Docs"}
  //               />
  //             </FlxGrid>
  //           </ScreenContent>
  //         </>
  //       )}
  //     </ScreenContent>
  //   </LoanDrilldownTabPanel>
  // );
};

const RedesignContent = ({ children }) => {
  const [quickFilter, setQuickFilter] = useState("");
  const { updateUnnestedObject } = useUnderwritingHook();
  const loanDrilldown = useSelector((state) => state.loanDrilldown);
  const dispatch = useDispatch();
  const ref = useRef();
  const [redesign, setRedesign] = useState(false);
  const { isHighLevelUser } = useReduxHook();
  const entities = useSelector(
    (state) => state?.loanDrilldown?.entities || DUMMY_ENTITIES || []
  );
  return (
    <LoanDrilldownTabPanel>
      <TitledHeaderWithSearch
        title={"Loan Entity"}
        endContent={<LoanDrilldownButtonAddEntity />}
        borderColor={"#eeeeee"}
      />
      <ScreenContent
        sx={{
          flexGrow: 1,
          width: "100%",
          margin: "0px auto",
        }}
      >
        <EntityCardList entities={entities} />
      </ScreenContent>
    </LoanDrilldownTabPanel>
  );
};

const EntityCardList = ({ entities }) => {
  const entitiess = useSelector(
    (state) => state?.loanDrilldown?.entities || []
  );

  return (
    <Flx
      gap={1}
      // grow={1}
      column
      fw
      //
      // wrap
      // sx={{ alignItems: "flex-start" }}
      // ac
      jc
    >
      {entities.map((ent) => (
        <LoanEntityDetailsCard key={ent?._id} entity={ent} />
      ))}
    </Flx>
  );
};

// --------------------------------------------------------------------------------------------------------------------
// --------------------------------------------------------------------------------------------------------------------
// --------------------------------------------------------------------------------------------------------------------
// ------------------------------------------------------- OLD---------------------------------------------------------
// --------------------------------------------------------------------------------------------------------------------
// --------------------------------------------------------------------------------------------------------------------
// --------------------------------------------------------------------------------------------------------------------

/**
 * SECTIONS
 */

const EntityDetailsGroup = ({ quickFilter, onUpdateFn }) => {
  const borrowerEntity = useSelector(
    (state) => state.loanDrilldown?.borrowerEntity
  );

  const fields = useMemo(
    () => [
      {
        name: "entityName",
        label: "Entity Name",
        type: "text",
      },

      {
        name: "entityStateOfOrganization",
        label: "Entity State Of Organization",
        type: "select",
        options: selectOptionsUsaStates,
      },
      {
        name: "entityType",
        label: "Entity Type",
        type: "select",
        options: selectOptionsEntityType,
      },
      {
        name: "entityOrganizationDate",
        label: "Entity Organization Date",
        type: "date",
      },
      {
        name: "entityEINNumber",
        label: "Entity EIN Number",
        type: "text",
      },

      {
        name: "entityGoodstandingDate",
        label: "Entity Goodstanding Date",
        type: "date",
      },
      {
        name: "entityNotes",
        label: "Entity Notes",
        type: "stringMultiline",
      },
    ],
    []
  );

  return (
    <TitledCard
      variant="h3"
      title="Entity Details"
      icon={<StoreOutlined className="thin" />}
      // cardSx={{ flexGrow: 0, flexBasis: "680px", flexShrink: 1 }}
    >
      <EditableDataFieldsRenderer
        fields={fields}
        data={borrowerEntity}
        onUpdateFn={onUpdateFn}
        quickFilter={quickFilter}
      />
    </TitledCard>
  );
};

const EntityAddressSection = ({ quickFilter, onUpdateFn }) => {
  const { updateUnnestedObject } = useUnderwritingHook();
  const loanDrilldown = useSelector((state) => state.loanDrilldown);

  const dispatch = useDispatch();

  const entityAddress = useMemo(
    () => loanDrilldown?.borrowerEntity?.entityAddress || {},
    [loanDrilldown]
  );

  const onAddressUpdate = ({ values, stopLoadingFn }) => {
    const payload = {
      entityAddress: {
        ...entityAddress,
        ...values,
      },
    };

    updateUnnestedObject({
      loanId: loanDrilldown?._id,
      data: payload,
      objectName: "borrowerEntity",
      onSuccessFn: (response) => {
        stopLoadingFn();
        dispatch(loanDrilldownSet(response));
      },
    });
  };

  const addressGroup = useMemo(() => {
    return [
      {
        name: "streetNumber",
        label: "Street Number",
      },
      {
        name: "streetName",
        label: "Street Name",
      },
      {
        name: "city",
        label: "City",
      },
      {
        name: "state",
        label: "State",
      },
      {
        name: "zip",
        label: "Zip Code",
      },
      {
        name: "county",
        label: "County",
      },
      {
        name: "country",
        label: "Country",
      },
    ];
  }, []);

  const displayedFullAddress = useMemo(() => {
    return `${entityAddress?.streetNumber || ""} ${entityAddress?.streetName || ""}, ${entityAddress?.city || ""}, ${entityAddress?.state || ""} ${entityAddress?.zip || ""}`;
  }, [entityAddress]);

  return (
    <>
      <TitledCard
        title="Entity Address"
        icon={<LocationOnOutlined className="thin" />}
        variant="h3"
        // cardSx={{ flexBasis: "420px", flexGrow: 1, flexShrink: 0 }}
      >
        {isEmpty(entityAddress) ? (
          <CreateEntityAddressContent />
        ) : (
          <>
            <Flx
              gap={0.5}
              wrap
              sx={{
                background: grey[100],
                p: 1,
                borderRadius: 2,
                mb: 2,
                mt: -0.5,
                flexGrow: 0,
              }}
            >
              <Txt bold>{displayedFullAddress}</Txt>
            </Flx>

            <EditableDataFieldsRenderer
              quickFilter={quickFilter}
              fields={addressGroup}
              data={entityAddress}
              onUpdateFn={onAddressUpdate}
            />
          </>
        )}
      </TitledCard>
    </>
  );
};

const EntityMembersCard = () => {
  const borrowers = useSelector((state) => state.loanDrilldown?.borrowers);

  return (
    <TitledCard
      variant="h3"
      title={"Entity Members"}
      fw
      // cardSx={{ flexGrow: 0, flexBasis: "500px", flexShrink: 0 }}
      icon={<PeopleOutlined className="thin" />}
      headerEndContent={<AddLoanEntityMembersButton />}
    >
      {/* <EntityOwnershipPieChart borrowers={borrowers} /> */}
      <EntityMembersTable borrowers={borrowers} />
    </TitledCard>
  );
};

const AddLoanEntityMembersButton = ({ children }) => {
  const loanDrilldown = useSelector((state) => state.loanDrilldown);

  const [show, setShow] = useState(false);
  const [borrowerId, setBorrowerId] = useState(null);
  const [entityPercentOwnership, setEntityPercentOwnership] = useState(null);
  const [isGuarantor, setIsGuarantor] = useState(null);

  const { loading, updateBorrower } = useUnderwritingHook();
  const dispatch = useDispatch();

  const borrowers = useMemo(
    () => loanDrilldown?.borrowers || [],
    [loanDrilldown]
  );

  const mappedBorrowers = useMemo(() => {
    return borrowers.map((borrower) => ({
      value: borrower._id,
      label: `${borrower.firstName} ${borrower.lastName}`,
    }));
  }, [borrowers]);

  const onCancel = () => {
    setShow(false);
    setEntityPercentOwnership(null);
    setBorrowerId(null);
    setIsGuarantor(null);
  };

  const handleOnBorrowerSelect = (bid) => {
    setBorrowerId(bid);
    const borrower = borrowers?.find((b) => b._id === bid);
    console.log("borrower", borrower);
    if (borrower?.entityPercentOwnership) {
      setEntityPercentOwnership(borrower.entityPercentOwnership);
    }
    if (isBoolean(borrower?.isGuarantor)) {
      setIsGuarantor(borrower.isGuarantor);
    }
  };

  const booleanOptions = useMemo(
    () => [
      { label: "Yes", value: true },
      { label: "No", value: false },
    ],
    []
  );

  const onAddClick = () => {
    updateBorrower({
      borrowerId: borrowerId,
      loanId: loanDrilldown?._id,
      data: { entityPercentOwnership, isGuarantor },
      onSuccessFn: (response) => {
        dispatch(loanDrilldownSet(response));
        onCancel();
      },
    });
  };
  if (size(borrowers) < 1) {
    return null;
  }
  return (
    <>
      <Tooltip title="Edit Entity Members">
        <IconButton
          onClick={() => setShow(true)}
          sx={{ position: "absolute", right: 12, top: 16 }}
          size="small"
        >
          <EditOutlined />
        </IconButton>
      </Tooltip>
      <BasicModal
        title={"Edit Entity Members"}
        show={show}
        maxWidth="xs"
        onClose={onCancel}
      >
        <Flx column gap={5}>
          <InputWrapper label="Select Loan Borrower">
            <SelectInput
              options={mappedBorrowers}
              value={borrowerId}
              onChange={handleOnBorrowerSelect}
            />
          </InputWrapper>
          {isNil(borrowerId) ? null : (
            <>
              <InputWrapper fullWidth label="Entity Percentage Ownership">
                <PercentInput
                  value={entityPercentOwnership}
                  showSlider
                  onChange={setEntityPercentOwnership}
                />
              </InputWrapper>
              <InputWrapper fullWidth label="Is Guarantor">
                <SelectToggleInput
                  value={isGuarantor}
                  onChange={setIsGuarantor}
                  options={booleanOptions}
                />
              </InputWrapper>
            </>
          )}
          <Flx fw end>
            <Button
              loading={loading}
              disabled={isNil(borrowerId) || isNil(entityPercentOwnership)}
              onClick={onAddClick}
            >
              Update Entity Members
            </Button>
          </Flx>
        </Flx>
      </BasicModal>
    </>
  );
};

const EntityMembersTable = ({ borrowers }) => {
  const ref = useRef();

  const rowData = useMemo(() => borrowers, [borrowers]);

  const columnDefs = useMemo(
    () => [
      {
        headerName: "Loan Borrowers",
        valueGetter: (params) =>
          `${params.data.firstName} ${params.data.lastName}`,
        flex: 1,
        cellStyle: (params) =>
          params.node.rowPinned === "bottom" ? { fontWeight: "bold" } : {},
      },
      {
        headerName: "Is Guarantor",
        field: "isGuarantor",
        width: 120,
        cellRenderer: (params) => {
          return params.node.rowPinned === "bottom" ? null : (
            <Checkbox checked={!!params.value} disabled />
          );
        },
        type: "boolean",
      },
      {
        headerName: "Ownership %",
        type: "percent",
        aggFunc: "sum",
        width: 120,
        cellStyle: (params) => {
          if (params.node.rowPinned === "bottom") {
            return {
              backgroundColor: params.value === 1 ? green[100] : red[100],
            };
          }
          return {};
        },
        field: "entityPercentOwnership",
      },
    ],
    []
  );

  const totalOwnership = useMemo(() => {
    return borrowers.reduce((sum, b) => {
      const pct = !isNil(b.entityPercentOwnership)
        ? b.entityPercentOwnership
        : 0;
      return sum + pct;
    }, 0);
  }, [borrowers]);

  const defaultColDef = useMemo(
    () => ({
      filter: true,
      enableRowGroup: true,
      enablePivot: true,
      suppressHeaderFilterButton: true,
      suppressHeaderMenuButton: true,
      menuTabs: ["filterMenuTab"],
    }),
    []
  );

  const columnTypes = useMemo(() => {
    return {
      ...columnTypesPercent(),
      ...columnTypesBoolean(),
    };
  }, []);

  return (
    <AgGridTableWrapper simpleTable suppressMinHeightWhenPopulated={rowData}>
      <AgGridReact
        ref={ref}
        rowData={rowData}
        columnDefs={columnDefs}
        defaultColDef={defaultColDef}
        columnTypes={columnTypes}
        pinnedBottomRowData={[
          {
            firstName: "Total Ownership",
            lastName: "",
            entityPercentOwnership: totalOwnership,
          },
        ]}
        allowDragFromColumnsToolPanel={false}
        domLayout={"autoHeight"}
        enableCellTextSelection
      />
    </AgGridTableWrapper>
  );
};

const CreateEntityAddressContent = ({ children }) => {
  const loanDrilldown = useSelector((state) => state.loanDrilldown);
  const entityAddress = useMemo(
    () => loanDrilldown?.borrowerEntity?.entityAddress || {},
    [loanDrilldown]
  );
  const dispatch = useDispatch();
  const { loading, updateUnnestedObject } = useUnderwritingHook();

  const onAddressCreate = (data) => {
    let payload = {};

    if (isEmpty(entityAddress)) {
      payload = data;
    }

    updateUnnestedObject({
      loanId: loanDrilldown?._id,
      data: payload,
      objectName: "borrowerEntity",
      onSuccessFn: (response) => {
        dispatch(loanDrilldownSet(response));
      },
    });
  };

  return (
    <RffForm
      submitText="Save Address"
      onSubmit={onAddressCreate}
      loading={loading}
      sx={{ pt: 2 }}
    >
      <RffAddressGeolocateField
        name={`entityAddress`}
        label="Enter the Entity address"
      />
    </RffForm>
  );
};

const DUMMY_ENTITIES = [
  {
    _id: "69038e00a269df23a55668ec",
    entityName: "Musko LLC",
    entityType: "LLC",
    entityStateOfOrganization: "FL",
    entityEINNumber: "36-4928049",
    entityGoodstandingDate: "2025-11-05T05:00:00+00:00",
    applicantEntityPercentOwnership: 0.5,
    applicantHasExistingEntity: true,
    entityAddress: {
      streetNumber: "2778",
      streetName: "North University Drive",
      streetAddress: "2778 North University Drive",
      city: "Sunrise",
      state: "FL",
      zip: "33322",
      county: "Broward",
      country: "United States",
      countryCode: "US",
      latitude: 26.15819,
      longitude: -80.25713,
      coordinateTuple: [26.15819, -80.25713],
      fullAddress: "2778 North University Drive, Sunrise, FL 33322",
      score: 1,
      id: "eH8smjGv6T6IO0IvEu0JAA-1762800693184",
    },
    entityMembers: [
      {
        _id: "64f10001a269df23a5566001",
        firstName: "Elon",
        middleName: "Reeve",
        lastName: "Musko",
        fullName: "Elon Reeve Musko",
        entityPercentOwnership: 50.0,
        isGuarantor: true,
        title: "Manager",
      },

      // Nested entity member (expandable row in your grid)
      {
        _id: "64f10001a269df23a5566999",
        memberType: "entity",
        entityName: "Musko Holdings LLC",
        entityPercentOwnership: 35.0,
        isGuarantor: false,
        title: "Other",
        entityMembers: [
          {
            _id: "64f10001a269df23a5567001",
            firstName: "Ava",
            middleName: "Jean",
            lastName: "Holden",
            fullName: "Ava Jean Holden",
            entityPercentOwnership: 60.0,
            isGuarantor: true,
            title: "Manager",
          },
          {
            _id: "64f10001a269df23a5567002",
            firstName: "Noah",
            middleName: null,
            lastName: "Holden",
            fullName: "Noah Holden",
            entityPercentOwnership: 40.0,
            isGuarantor: false,
            title: "Member",
          },
        ],
      },

      {
        _id: "64f10001a269df23a5566002",
        firstName: "Kimbal",
        middleName: null,
        lastName: "Musko",
        fullName: "Kimbal Musko",
        entityPercentOwnership: 10.0,
        isGuarantor: false,
        title: "Member",
      },
      {
        _id: "64f10001a269df23a5566003",
        firstName: "Tosca",
        middleName: null,
        lastName: "Musko",
        fullName: "Tosca Musko",
        entityPercentOwnership: 5.0,
        isGuarantor: false,
        title: "Officer",
      },
    ],
  },

  // {
  //   _id: "69038e00a269df23a55668ec",
  //   applicantEntityPercentOwnership: 0.5,
  //   applicantHasExistingEntity: true,
  //   entityAddress: {
  //     city: "Sunrise",
  //     coordinateTuple: [26.15819, -80.25713],
  //     country: "United States",
  //     countryCode: "US",
  //     county: "Broward",
  //     fullAddress: "2778 North University Drive, Sunrise, FL 33322",
  //     id: "eH8smjGv6T6IO0IvEu0JAA-1762800693184",
  //     latitude: 26.15819,
  //     longitude: -80.25713,
  //     score: 1,
  //     state: "FL",
  //     streetAddress: "2778 North University Drive",
  //     streetName: "North University Drive",
  //     streetNumber: "2778",
  //     zip: "33322",
  //   },
  //   entityEINNumber: "36-4928049",
  //   entityGoodstandingDate: "2025-11-05T05:00:00+00:00",
  //   entityMembers: [],
  //   entityName: "Musko LLC ",
  //   entityStateOfOrganization: "FL",
  //   entityType: "LLC",
  // },
  // {
  //   _id: "690e44cf9aaf83cd71fc0edd",
  //   applicantEntityPercentOwnership: 1,
  //   applicantHasExistingEntity: true,
  //   entityAddress: {
  //     city: "Staten Island",
  //     coordinateTuple: [40.605659, -74.135796],
  //     country: "United States",
  //     countryCode: "US",
  //     county: "Richmond",
  //     fullAddress: "732 Westwood Avenue, Staten Island, NY 10314",
  //     id: "4V1pLAS5mFuA2isnbY4xbA-1763585800665",
  //     latitude: 40.605659,
  //     longitude: -74.135796,
  //     score: 1,
  //     state: "NY",
  //     streetAddress: "732 Westwood Avenue",
  //     streetName: "Westwood Avenue",
  //     streetNumber: "732",
  //     zip: "10314",
  //   },
  //   entityAssets: true,
  //   entityEINNumber: "334868149",
  //   entityGoodstandingDate: "2025-11-20T05:00:00+00:00",
  //   entityMembers: [],
  //   entityName: "31 Grace Street Realty LLC\t",
  //   entityOrganizationDate: "2025-04-30T04:00:00+00:00",
  //   entityStateOfOrganization: "NJ",
  //   entityType: "LLC",
  // },
];

export default LoanDrilldownEntityTab;
